import { createRootRoute, Outlet, redirect } from '@tanstack/react-router'

import { OutageBanner, Toaster, TooltipProvider } from '@/components/ui'
import { useRouteTitle } from '@/hooks'
import { redirects } from '@/lib/redirects'
import { PageTracker } from '@/services/tracking'

export const Route = createRootRoute({
  beforeLoad: ({ location }) => {
    const normalizedPath = location.pathname.toLowerCase()

    if (redirects[normalizedPath]) {
      throw redirect({ to: redirects[normalizedPath] })
    }

    if (normalizedPath !== location.pathname) {
      const knownRoutes = ['/login', '/sign-up', '/projects']
      if (knownRoutes.some((route) => normalizedPath.startsWith(route))) {
        throw redirect({ to: normalizedPath })
      }
    }
  },
  component: RootComponent,
})

function RootComponent() {
  useRouteTitle()

  return (
    <TooltipProvider delayDuration={200} skipDelayDuration={300}>
      <PageTracker />
      <div className="flex h-screen flex-col">
        <OutageBanner />
        <div className="flex-1 min-h-0 overflow-y-auto">
          <Outlet />
        </div>
      </div>
      <Toaster />
      {/* {import.meta.env.DEV && <TanStackRouterDevtools />} */}
    </TooltipProvider>
  )
}
